// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__tSyV6","title":"AfterFrontImage_title__2_9jy"};